import React, { useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../components/Axios/axios';
import requests from '../../components/Requests/requests';
import Banner from '../../components/Banner/Banner';
import LoadingBanner from '../../components/Banner/LoadingBanner';
import Row from '../../components/Row/Row';
import LoadingRow from '../../components/Row/LoadingRow';
import Pagination from '../../components/Pagination/Pagination';
import HeaderNavigation from '../../components/HeaderNavigation/HeaderNavigation';
import MessageManager from '../../components/MessageManager/MessageManager';
import { motion } from "framer-motion";

function Movies() {
    let { id, page } = useParams();
    const [apiResponse, setApiResponse] = useState([]);
    const [error, setError] = useState(false);
    const [openLoader, setOpenLoader] = React.useState(false);
    const handleOpenLoader = () => setOpenLoader(true);
    const handleCloseLoader = () => setOpenLoader(false);
    page = (!page) ? 1 : page;

    if (!id) {
        id = 'trending';
    }

    useEffect(() => {
        handleOpenLoader();
        let url;
        async function fetchData() {
            if (id == 'trending') {
                url = requests.fetchMovies + page + '?sort=trending&order=-1&limit=18'
            } else {
                url = requests.fetchMovies + page + '?genre=' + id + '&order=-1&limit=18';
            }
            const request = await axios.get(url)
            .then(request => {
                setApiResponse(request.data);
            })
            .catch(function (error) {
                setError('Sorry, we were unable to load movie data via the API. Try updating your API server settings.');
            });
            
            handleCloseLoader();
            return request;
        }
        fetchData();
    }, [id]);
    if (error) {
        return (
            <motion.div 
                className="show-container"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
            >
            <MessageManager showMessage={true} type={'error'}>
                {error}
            </MessageManager>
            </motion.div>   
        )    
    } else {
        return (
            <>
            <motion.div 
                    className="show-container"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                >
                    <div className="banner-container">
                        <HeaderNavigation showMovieStack={true} />
                        {page == 1 &&
                            <Banner data={apiResponse} movieNo={0} showBanner={!openLoader}/>
                        }
                        {openLoader && 
                            <LoadingBanner/>
                        }
                    </div>
                    <div className="inner-content-body">
                        <Row title={id} data={apiResponse} isLargeRow />
                        {openLoader && 
                            <LoadingRow/>
                        }
                        <Pagination pageNumber={page} />
                        <MessageManager/>
                    </div>
                </motion.div>
            </>
        )
    }
}

export default Movies;